import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Alert, UncontrolledTooltip, Table, Spinner, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import AuthFunctions from '../services/AuthService';
import AdminFunctions from '../admin/AdminFunctions';
import Session from '../auth/Session';
import { FaSort } from 'react-icons/fa'
import utilities from '../util/utilities';
import { Typeahead } from 'react-bootstrap-typeahead';
import moment from "moment";

//Warm Gray - #5C5C5C
//Orange - #F26230 #FFFFFF
//Light Gray - #DDDDDD
//Almost Black - #373737
//backgroundColor: '#F26230', color: '#FFFFFF'

export class LeaseDetailsCriticalDates extends Component {
    static displayName = LeaseDetailsCriticalDates.name;

    constructor(props) {
        super(props);
        const search = this.props.location.search;
        const params = new URLSearchParams(search);
        const id = params.get('id');

        this.state = {
            clientOptions: [],
            client: null,
            clientText: null,
            search: null,
            criticalDates: [],
            isAdmin: false,
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            loading: false,
            noResults: false,
            currentPage: 1,
            itemsPerPage: 100000,
            numberOfPages: 0,
            testType: 'Selection',
            testLevel: 'MA',
            leaseId: id,
            typeOptions: [{ label: "Expiration Date", value: "Expiration Date" }, { label: "Option to Renew", value: "Option to Renew" },
            { label: "Termination Option", value: "Termination Option" },
            { label: "Right of First Refusal", value: "Right of First Refusal" },
            { label: "Other", value: "Other" }],
            lease: {} //For header
        };
        this.checkAuthenticated();
        this.GetLease(); //For header
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        var isAdmin = false;
        var isWrite = false;
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
        if (isAuthenticated) {
            isAdmin = await AdminFunctions.isAdminAsync();
            isWrite = await AdminFunctions.isRole("Write");
        }
        this.setState({ isAdmin: isAdmin || isWrite });
    }

    async componentDidMount() {
        var _token = Session.getToken();
        //this.ShowAllLeases();
        this.GetCriticalDates();
        //var data = [{ sd_num: '20', sd_region: 'Office', sd_building: 'Governors Row', sd_address: '123 test st', sd_city: 'testcity', sd_state: 'IL', sd_sqft: 5108, sd_status: 1 },
        //    { sd_num: '20', sd_region: 'Office', sd_building: 'Governors Row', sd_address: '123 test st', sd_city: 'testcity', sd_state: 'IL', sd_sqft: 5108, sd_status: 0 }];
        //this.setState({ criticalDates: data });
    }


    //For Pageing!
    handleClick(event) {
        let id = Number(event.target.id);

        if (id === 0) {
            this.setState({
                currentPage: 1
            });
        } else if (id === -1) {
            this.setState({
                currentPage: Math.ceil(this.state.criticalDates.length / this.state.itemsPerPage)
            });
        } else {
            this.setState({
                currentPage: Number(event.target.id)
            });
        }
    }

    async handleChange(event) {
        this.setState({ currentPage: Number(event.target.value) });
    }

    async handlePageSizeChange(event) {
        let pageSize = Number(event.target.value);
        this.setState({ itemsPerPage: pageSize });
        if (this.state.currentPage > Math.ceil(this.state.criticalDates.length / pageSize)) {
            this.setState({ currentPage: Math.ceil(this.state.criticalDates.length / pageSize) })
        }
    }

    handleSort(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.criticalDates;
        data.sort((a, b) => {
            var valA = a[column] === null ? '' : a[column];
            var valB = b[column] === null ? '' : b[column];
            valA = valA.toString(); //How do we fix?
            valB = valB.toString(); //How do we fix?
            return valA.localeCompare(valB);
        });
        //data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            criticalDates: data,
            sort: {
                column,
                direction
            }
        })
    }
    handleSortInt(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.criticalDates;
        data.sort((a, b) => {
            var valA = a[column] === null ? '' : a[column];
            var valB = b[column] === null ? '' : b[column];
            //return valA.localeCompare(valB);
            if (valA < valB) {
                return -1;
            } else if (valA > valB) {
                return 1;
            } else {
                return 0;
            }
        });
        //data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            criticalDates: data,
            sort: {
                column,
                direction
            }
        })
    }
    render() {

        // Logic for displaying criticalDates
        const currentItems = this.state.criticalDates;

        const renderItems = currentItems.map((candidate, i) => {
            return (
                <tr key={i}>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        {candidate.editMode === false && (
                            <div>
                                {candidate.cd_type}
                            </div>
                        )}
                        {candidate.editMode === true && (
                            <div>
                                <select
                                    options={this.state.typeOptions}
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    components={{
                                        Option
                                    }}
                                    onChange={(e) => {
                                        var criticalDatesTemp = this.state.criticalDates;
                                        criticalDatesTemp[i].cd_type = e.target.value;
                                        this.setState({ criticalDates: criticalDatesTemp });
                                    }}
                                    value={candidate.cd_type}
                                    style={{ 'width': '170px' }}
                                >
                                    <option key=''></option>
                                    {this.state.typeOptions.map(option => {
                                        return (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        )}
                    </td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        {candidate.editMode === false && (
                            <div>
                                {moment(candidate.cd_action, "YYYY-MM-DDTHH:mm:ss").format("MM/DD/yyyy")}
                            </div>
                        )}
                        {candidate.editMode === true && (
                            <div>
                                <input
                                    type="date"
                                    value={moment(candidate.cd_action, "YYYY-MM-DDTHH:mm:ss").format("yyyy-MM-DD")}
                                    onChange={(e) => {
                                        var criticalDatesTemp = this.state.criticalDates;
                                        criticalDatesTemp[i].cd_action = e.target.value;
                                        this.setState({ criticalDates: criticalDatesTemp });
                                    }}
                                    name="cd_action"
                                    id='cd_action'
                                    style={{ 'width': '113px' }}
                                />
                            </div>
                        )}
                    </td>

                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        {candidate.editMode === false && (
                            <div>
                                {candidate.cd_note}
                            </div>
                        )}
                        {candidate.editMode === true && (
                            <div>
                                <textarea
                                    type="textarea"
                                    value={candidate.cd_note}
                                    onChange={(e) => {
                                        var criticalDatesTemp = this.state.criticalDates;
                                        criticalDatesTemp[i].cd_note = e.target.value;
                                        this.setState({ criticalDates: criticalDatesTemp });
                                    }}
                                    name="cd_note"
                                    id='cd_note'
                                    style={{ 'width': '650px', 'height': '80px' }}
                                />

                            </div>
                        )}
                    </td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        {candidate.editMode === false && (
                            <div>

                                <Button
                                    color='primary'
                                    onClick={() => {
                                        var criticalDatesTemp = this.state.criticalDates;
                                        criticalDatesTemp[i].prevTerms = Object.assign({}, criticalDatesTemp[i]);
                                        criticalDatesTemp[i].editMode = true;
                                        this.setState({ criticalDates: criticalDatesTemp });
                                    }}
                                    className="g-orange-bg g-orange-c g-orange-button gButton"
                                    style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                    disabled={this.state.loading === true ? true : false}
                                    hidden={!this.state.isAdmin ? true : false}
                                >
                                    Edit
                                </Button>
                            </div>
                        )}
                        {candidate.editMode === true && (
                            <Button
                                color='primary'
                                onClick={() => {
                                    var criticalDatesTemp = this.state.criticalDates;
                                    if (this.IsEmpty(candidate) === true) {
                                        this.DeleteEmpty(i);
                                    }
                                    else {
                                        criticalDatesTemp[i].editMode = false;
                                        this.setState({ criticalDates: criticalDatesTemp });
                                        this.SaveCriticalDate(candidate, i);
                                    }

                                }}
                                className="g-orange-bg g-orange-c g-orange-button gButton"
                                style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                disabled={this.state.loading === true ? true : false}
                                hidden={!this.state.isAdmin ? true : false}
                            >
                                {this.IsEmpty(candidate) === false ? 'Save' : 'Delete'}
                            </Button>
                        )}
                        {candidate.editMode === true && candidate.rt_id !== 0 && (
                            <Button
                                color='primary'
                                onClick={() => {
                                    var criticalDatesTemp = this.state.criticalDates;
                                    criticalDatesTemp[i] = criticalDatesTemp[i].prevTerms;
                                    criticalDatesTemp[i].prevTerms = {};
                                    criticalDatesTemp[i].editMode = false;
                                    this.setState({ criticalDates: criticalDatesTemp });

                                }}
                                className="g-orange-bg g-orange-c g-orange-button gButton"
                                style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                disabled={this.state.loading === true ? true : false}
                                hidden={!this.state.isAdmin ? true : false}
                            >
                                Cancel
                            </Button>
                        )}
                        {candidate.editMode === true && candidate.cd_id !== 0 && (
                            <Button
                                color='primary'
                                onClick={() => {
                                    this.DeleteExisting(candidate, i);
                                }}
                                className="g-orange-bg g-orange-c g-orange-button gButton"
                                style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                disabled={this.state.loading === true ? true : false}
                                hidden={!this.state.isAdmin ? true : false}
                            >
                                Delete
                            </Button>
                        )}
                    </td>
                </tr>
            )
        });

        return (
            <div className="pageDiv">
                <div id="head">
                    <h3 style={{ textAlign: 'center' }}>Lease Details</h3>
                </div>
                <div id="body" className="g-warm-gray-c">
                    <Row>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>
                            <label className="g-almost-black-c addressTitle">
                                {this.state.lease.sd_address}<br />
                                {this.state.lease.sd_city}, {this.state.lease.sd_state} {this.state.lease.sd_zip}
                            </label> {/*//For header*/}
                        </Col>
                    </Row>
                    <Row className="g-warm-gray-bg g-warm-gray-c" style={{ 'textAlign': 'center' }}>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Summary?id=' + this.state.leaseId}
                            >
                                Summary
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-RentTerms?id=' + this.state.leaseId}
                            >
                                Rent Terms
                            </NavLink>
                        </Col>
                        <Col className="g-orange-bg g-orange-c">
                                Critical Dates
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Notes?id=' + this.state.leaseId}
                            >
                                Notes
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Documents?id=' + this.state.leaseId}
                            >
                                Documents
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Contacts?id=' + this.state.leaseId}
                            >
                                Contacts
                            </NavLink>
                        </Col>
                    </Row>
                </div>
                <div id="body" className="g-light-gray-c">
                    <Row className="rowSpacing">
                        <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '100px' }}>
                                            Type
                                            <FaSort
                                                color={this.state.sort.column === 'cd_type' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSortInt('cd_type')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'width': '140px' }}>
                                            Critical Date
                                            <FaSort
                                                color={this.state.sort.column === 'cd_action' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('cd_action')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '650px' }}>
                                            Notes/Comments
                                            <FaSort
                                                color={this.state.sort.column === 'cd_note' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('cd_note')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c buttonColumn" style={{ 'width': '106px' }}>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.loading === true && this.state.loadingDocument === false ? (
                                        <tr>
                                            <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '50vh', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                <Spinner color="primary" children='' />
                                            </td>
                                        </tr>

                                    ) : (
                                        <>
                                            {!this.state.noResults ? (
                                                <>
                                                    {renderItems}
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td style={{ 'textAlign': 'right' }}>
                                                            <Button
                                                                color='primary'
                                                                onClick={() => {
                                                                    this.AddRows(1);
                                                                }}
                                                                className="g-orange-bg g-orange-c g-orange-button gButton"
                                                                style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                                                    disabled={this.state.loading === true ? true : false}
                                                                    hidden={!this.state.isAdmin ? true : false}
                                                            >
                                                                Add
                                                                </Button>
                                                                <Link
                                                                    to="/Lease/ActiveLeases?search=1"
                                                                    color='primary'
                                                                    className="g-orange-bg g-orange-c g-orange-button gButton btn btn-primary"
                                                                    style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", padding: '5px' }}
                                                                    disabled={this.state.loading === true ? true : false}
                                                                >
                                                                    Back To List
                                                                </Link>
                                                        </td>
                                                    </tr>
                                                </>
                                            ) : (
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                    <h5>No Results Found</h5>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }

    async GetCriticalDates() {
        const token = Session.getToken();
        const response = await fetch('api/Leases/GetCriticalDates?id=' + this.state.leaseId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        })
        const data = await response.json();
        this.setState({ criticalDates: data });
    }
    AddRows(number) {
        for (var i = 0; i < number; i++) {
            var newRow = { cd_id: 0, sd_id: this.state.leaseId, cd_email: null, cd_type: '', cd_action: null, cd_reminder: null, cd_note: '', cd_status: true, active: true, editMode: true };
            var criticalDatesTemp = this.state.criticalDates;
            criticalDatesTemp.push(newRow);
            this.setState({ criticalDates: criticalDatesTemp });
        }
    }
    IsEmpty(candidate) {
        if (candidate.cd_type || candidate.cd_action || candidate.cd_reminder || candidate.cd_note) {
            //If anything is filled out, it's not empty.
            return false;
        }
        if (candidate.cd_id) {
            //If it's not a new item, it's not considered empty for this.
            return false;
        }
        return true;
    }
    DeleteEmpty(index) {
        var criticalDatesTemp = this.state.criticalDates;
        criticalDatesTemp.splice(index, 1);
        this.setState({ criticalDates: criticalDatesTemp });
    }
    async SaveCriticalDate(candidate, index) {
        const token = Session.getToken();
        const response = await fetch('api/Leases/EditCriticalDate', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(candidate)
        })

        const data = await response.json();

        if (data) {
            if (data.cd_id > 0) {
                var criticalDatesTemp = this.state.criticalDates;
                criticalDatesTemp[index].cd_id = data.cd_id;
                this.setState({ contacts: criticalDatesTemp });
            }
        }
    }
    async DeleteExisting(candidate, index) {
        if (window.confirm("Are you sure you want to delete this Critical Date?") === true) {
            const token = Session.getToken();
            const response = await fetch('api/Leases/DeleteCriticalDate?id=' + candidate.cd_id, {
                method: 'GET',
                headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            })

            var criticalDatesTemp = this.state.criticalDates;
            criticalDatesTemp.splice(index, 1);
            this.setState({ criticalDates: criticalDatesTemp });
        }
    }
    //For header
    async GetLease() {
        const token = Session.getToken();
        const response = await fetch('api/Leases/GetLease?id=' + this.state.leaseId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },

        })
        const data = await response.json();
        this.setState({ lease: data });
    }
}

